"use strict";
require('common/directives/paginationDirective');
require('common/directives/indeterminateDirective');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module("confirmation", ['templates', 'paginationDirective', 'indeterminateDirective', 'ui.bootstrap']);
app.controller("tableCtrl", require('./tableCtrl'));
app.controller('navCtrl', ['$scope', navCtrl]);
app.service('dataService', require('./dataService'));
app.filter('dateFormat', function() {
  return function(date) {
    return moment(date).format("DD.MM.YYYY");
  };
});
app.filter('paginate', function() {
  return function(array, page, pagesize) {
    if (array.length < page * pagesize)
      return [];
    else
      return array.slice(page * pagesize, (page + 1) * pagesize);
  };
});
app.run(['dataService', function(dataService) {
  dataService.load();
}]);
module.exports = app;
